import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { UiModule } from "./ui/ui.module";
import { NewOpenChartComponent } from "./components/mb-dashboard/new-open-chart/new-open-chart.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { MonthlyChartComponent } from "./components/mb-dashboard/monthly-chart/monthly-chart.component";
import { NewOpenBranchChartComponent } from "./components/mb-dashboard/new-open-branch-chart/new-open-branch-chart.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NgbAlertModule,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbPaginationModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { AuthRoutingModule } from "../account/auth/auth-routing";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatExpansionModule } from "@angular/material/expansion";
import { QrCodeModule } from "ng-qrcode";
import { MatAutocompleteModule } from "@angular/material/autocomplete";

@NgModule({
  declarations: [
    NewOpenChartComponent,
    MonthlyChartComponent,
    NewOpenBranchChartComponent,
    
  ],
  imports: [
    CommonModule,
    UiModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    NgbAlertModule,
    UiModule,
    AuthRoutingModule,
    TranslateModule,
    FormsModule,
    NgSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatExpansionModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbPaginationModule,
    NgbDatepickerModule,
    NgSelectModule,
    QrCodeModule,
    MatAutocompleteModule,
  ],
  exports: [
    NewOpenChartComponent,
    MonthlyChartComponent,
    NewOpenBranchChartComponent,
    
  ],
})
export class SharedModule {}
